
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 13.2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"a",attrs:{"d":"M11.591 2.2A1.773 1.773 0 119.819.413 1.78 1.78 0 0111.591 2.2zm0 0"}}),_c('path',{staticClass:"a",attrs:{"d":"M9.818 4.4A2.2 2.2 0 1112 2.2a2.193 2.193 0 01-2.182 2.2zm0-3.575A1.375 1.375 0 1011.181 2.2 1.371 1.371 0 009.818.825zM11.591 11a1.773 1.773 0 11-1.773-1.788A1.78 1.78 0 0111.591 11zm0 0"}}),_c('path',{staticClass:"a",attrs:{"d":"M9.818 13.2A2.2 2.2 0 1112 11a2.193 2.193 0 01-2.182 2.2zm0-3.575A1.375 1.375 0 1011.182 11a1.371 1.371 0 00-1.364-1.375zM3.954 6.6a1.773 1.773 0 11-1.773-1.788A1.78 1.78 0 013.954 6.6zm0 0"}}),_c('path',{staticClass:"a",attrs:{"d":"M2.182 8.8a2.2 2.2 0 010-4.4 2.2 2.2 0 010 4.4zm0-3.575A1.375 1.375 0 103.546 6.6a1.371 1.371 0 00-1.364-1.375zm0 0"}}),_c('path',{staticClass:"a",attrs:{"d":"M3.47 6.336a.544.544 0 01-.475-.278.553.553 0 01.2-.75l5.061-2.909A.542.542 0 019 2.605a.553.553 0 01-.2.75L3.739 6.264a.538.538 0 01-.269.072zm5.06 4.538a.538.538 0 01-.269-.072L3.2 7.893a.553.553 0 01-.2-.75.542.542 0 01.744-.206l5.061 2.909a.553.553 0 01.2.75.545.545 0 01-.475.278zm0 0"}})])
          )
        }
      }
    